




import Vue from 'vue'
import activeInfoPage from '@/components/Ui/ActiveInfoPage/ActiveInfoPage.vue'
import NewsletterActiveInfoPage from '@/activePages/Newsletter/Info-stuff'
// import Student from '@/models/Students/Student'
import Mailing from '@/models/mailing/mailing'

export default Vue.extend({
  name: 'NewsletterInfoStuff',
  props: {
    id: String
  },
  data () {
    return {
      config: NewsletterActiveInfoPage
    }
  },
  components: {
    activeInfoPage
  },
  computed: {
    mailing (): Mailing {
      return this.$store.state.mailing.mailings[this.id]
    }
  },
  mounted () {
    console.log('MAILLING', this.mailing)
  }
})
